import React from 'react'
import { FormatType, HUMAN_READABLE_FORMAT } from 'types/deck'

type Props = {
  intendedFormats?: FormatType[]
}

const IntendedFormats = ({ intendedFormats }: Props) => {
  if (!intendedFormats || !intendedFormats?.length) return <span>None</span>

  return <span>{intendedFormats.map(formatId => HUMAN_READABLE_FORMAT[formatId]).join(', ')}</span>
}

export default IntendedFormats
